module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/discipline/discipline.component.css
// module id = ./src/app/Pages/manage/discipline/discipline.component.css
// module chunks = main